import React from "react";
import Helpers from "../../../helpers/helperFunctions";
import Config from '../../../config/main';
import Loader from "../loader";
import VirtualGamesCompetitions from '../virtualGamesCompetitions';
export default function virtualGamesSportListTemplate() {
    let providers = Helpers.objectToArray(Config.virtualGames.providers),
        { selectedProvider, data, loaded } = this.props,
        providerId = Config.virtualGames.providers[selectedProvider]?.id,
        { selectedSportId } = this.state;

    return <div className="games-tabs-row" onClick={this.handleClick}>
        <ul>
            {
                providers.map((provider, index) => {
                    return <li onClick={() => this.props.handleSelectProvider(provider)} key={index}>
                        <span className={selectedProvider === provider.name && "active"}>
                            <i>{provider.name}</i>
                        </span>
                    </li>;
                })
            }
        </ul>
        {
            providerId && data
                ? loaded
                    ? <ul className="sport-list-menu-w">
                        {
                            data.map((sport, index) => {
                                return (
                                    <li className={sport.alias} onClick={this.selectSport(sport.id)} key={index}>
                                        <span className={selectedSportId === sport.id ? "active" : ""}>
                                            <i>{sport.name}</i>
                                        </span>
                                    </li>
                                );
                            })
                        }
                    </ul>
                    : <Loader />
                : null
        }
        {
            selectedSportId && <VirtualGamesCompetitions sportId={selectedSportId} key={selectedSportId + providerId} providerId={providerId} />
        }
    </div>;
};